export const isAppliedOffer = selectedOffer => {
  if (!selectedOffer) return 'NONE';
  if (selectedOffer.discountEligibilityError) return 'INVALID';
  return 'VALID';
};

export const appliedOfferResult = selectedOffer => {
  if (selectedOffer.discountEligibilityError) return 'FAIL';
  return 'SUCCESS';
};

export default {};
